module.exports = __webpack_public_path__ + "img/yuanmingyuan big (6).771d387f.jpg";